import React, { useEffect, useState } from 'react';
import Backdrop from 'components/Backdrop';
import { FaXmark } from "react-icons/fa6";

import './index.css';

type PopupProps = {
    handleCancel: () => void;
    handleSaveExit: () => void;
}

function SHSATExitPopup({
    handleCancel,
    handleSaveExit
}: PopupProps){
    return (
        <>
            <Backdrop />
            <div className='shsatExitPopup'>
                <div className='shsatExitPopup__Header'>
                    <div className='shsatExitPopup__HeaderTitle'>Exit Test</div>
                    <div className='shsatExitPopup__cancel' onClick={handleCancel}>
                        <FaXmark className='shsatExitPopup__cancelIcon'/>
                        <div>Cancel</div>
                    </div>
                </div>
                <div className='shsatExitPopup__body'>
                    I want to exit this test and finish later.
                </div>
                <div className='shsatExitPopup__Footer'>
                    <button className='shsatExitPopup__FooterButton' onClick={handleSaveExit}>Save and Return Later</button>
                </div>
            </div>
        </>
    );
}

export default SHSATExitPopup;